import { render } from "./tw-rate.vue?vue&type=template&id=17dc5fdc"
import script from "./tw-rate.vue?vue&type=script&lang=js"
export * from "./tw-rate.vue?vue&type=script&lang=js"
script.render = render

export default script